
export const groupsListStyles = {
  headerContainer: {
    padding: "0px 16px 16px 0px",
  },
  title: {
    color: "#000",
    fontSize: "22px",
    fontWeight: 600,
    lineHeight: "23px",
  },
  searchContainer: {
    display: "none",
  },
  rowContainer: {
    padding: "0px",
    paddingBottom: "16px",
  },
  addNewButton: {
    marginLeft: "0",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  addNewIcon: {
    fontSize: "28px",
    fontWeight: "bold",
  },
  viewGroupButton: {
    color: "#1A6BE8",
  },
  toggleContainer: {
    display: "flex",
    alignItems: "center",
  },
  editIcon: {
    color: "#1A6BE8",
  },
};

export const groupsListCSS = `
  /* GroupsList component styles */
  .text-td-alignment {
    text-align: center !important;
  }
  .customer-name-link {
    color: #1A6BE8;
    text-decoration: underline;
    cursor: pointer;
  }
  .customer-name-link:hover {
    color: #1557b8;
  }
  .groups-list-row-access {
    cursor: pointer;
  }
  .groups-list-row-access:hover {
    background-color: rgba(26, 107, 232, 0.06);
  }
  .groups-list-row-access--disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
  .groups-list-row-access--disabled:hover {
    background-color: transparent;
  }
  .groups-list-row-access--disabled .customer-name-link {
    cursor: not-allowed;
    color: #6c757d;
    text-decoration: none;
  }
`;

